'use client'

import { motion } from 'framer-motion'
import { useCartAnimationStore } from '@/store/use-cart-animation-store'

/**
 * Global flying cart item overlay.
 * Renders a small product image that flies from the source element to the cart icon.
 * Mount this component once in the layout (or page).
 */
export function FlyingCartItem() {
  const fly = useCartAnimationStore((s) => s.fly)

  if (!fly) return null

  return (
    <motion.div
      className="fixed z-[100] pointer-events-none"
      style={{
        top: 0,
        left: 0,
        width: 48,
        height: 48,
      }}
      initial={{
        x: fly.startX - 24,
        y: fly.startY - 24,
        scale: 1,
        opacity: 0.9,
      }}
      animate={{
        x: fly.endX - 24,
        y: fly.endY - 24,
        scale: 0.4,
        opacity: 0,
      }}
      transition={{
        duration: 0.65,
        ease: [0.2, 0.8, 0.2, 1],
      }}
    >
      <div className="w-12 h-12 rounded-lg overflow-hidden shadow-xl ring-2 ring-amber-400/50">
        <img
          src={fly.productImage}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
    </motion.div>
  )
}
